import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { toastSyncSuccess } from 'src/utils/syncToast'
import { useAuth } from 'src/contexts/auth'
import { RecordController } from 'src/controllers/record.controller'
import { PendingRecordUpdateDTO } from 'src/dto/record.dto'

const recordController = new RecordController()

export function useUpdatePendingRecord() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['updatePendingRecord'],
    mutationFn: (PendingRecordDto: PendingRecordUpdateDTO[]) =>
      recordController.updatePendingRecord(farmId!, PendingRecordDto),
    onError: () => {
      toast.error('Erro ao confirmar o registro')
    },
    onSuccess(data, variables) {
      const payload = variables[0]
      toastSyncSuccess(`Registro ${payload.status === 'Processado' ? 'confirmado' : 'rejeitado'} com sucesso`)
    }
  })
}
